import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getOrgDealflow = async () => {
  const { data, totalCount } = await fetcher.get({
    path: '/dealflow/organization',
  });
  return { data, totalCount };
};

export const updateDealflow = async (id, updateData) => {
  const data = await fetcher.put({
    path: `/dealflow/${id}`,
    body: updateData,
  });
  return data;
};

export const createDealflow = async (createData) => {
  const data = await fetcher.post({
    path: '/dealflow',
    body: createData,
  });
  return data;
};

export const deleteDealflow = async (id) => {
  const data = await fetcher.delete({
    path: '/dealflow',
    body: {
      id,
    },
  });
  return data;
};
